import { Tag, Tooltip } from 'antd';
import CcxComponentProps from '../../../core/CcxComponent';
import styles from './AppFormTag.module.less';
import { replaceIfRedis } from '../../../core/helpers';

interface Props extends CcxComponentProps {
    label: string;
    value?: string;
    size?: string;
    closable?: boolean;
    toolTip?: boolean;
    onClose?: Function;
}

function AppFormTag({
    label,
    closable,
    toolTip = true,
    size = '',
    onClose,
    testId = 'AppFormTag',
}: Props) {
    const onPreventMouseDown = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const labelReplace = replaceIfRedis(label);

    return toolTip ? (
        <Tooltip title={labelReplace} data-testid={`${testId}Tooltip`}>
            <Tag
                className={`${styles.AppFormTag}${size} ${styles.AppTagRadius}`}
                onMouseDown={onPreventMouseDown}
                closable={closable}
                onClose={onClose as any}
                data-testid={`${testId}Tag`}
            >
                {label.length <= 10
                    ? label
                    : `${labelReplace.substring(0, 10)}...`}
            </Tag>
        </Tooltip>
    ) : (
        <Tag
            className={`${styles.AppFormTag}${size} ${styles.AppTagRadius}`}
            onMouseDown={onPreventMouseDown}
            closable={closable}
            onClose={onClose as any}
            data-testid={`${testId}Tag`}
        >
            {labelReplace.length <= 10
                ? labelReplace
                : `${labelReplace.substring(0, 10)}...`}
        </Tag>
    );
}

export default AppFormTag;
